import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { CreateDropPart, ReferencedNft } from "@/entities/IDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import DropPartMarkdown from "../drops/view/part/DropPartMarkdown";
interface CreateDropStormPartProps {
  readonly partIndex: number;
  readonly part: CreateDropPart;
  readonly mentionedUsers: ApiDropMentionedUser[];
  readonly mentionedWaves: ApiMentionedWave[];
  readonly referencedNfts: ReferencedNft[];
  readonly onRemovePart: (partIndex: number) => void;
}
const CreateDropStormPart: React.FC<CreateDropStormPartProps> = t0 => {
  const $ = _c(17);
  const {
    partIndex,
    part,
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    onRemovePart
  } = t0;
  const t1 = partIndex + 1;
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="tw-whitespace-nowrap tw-text-md tw-font-normal tw-leading-5 tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out">Part {t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = part.content ?? "";
  let t4;
  if ($[2] !== mentionedUsers || $[3] !== mentionedWaves || $[4] !== referencedNfts || $[5] !== t3) {
    t4 = <div className="tw-pr-8"><DropPartMarkdown mentionedUsers={mentionedUsers} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={t3} onQuoteClick={_temp} /></div>;
    $[2] = mentionedUsers;
    $[3] = mentionedWaves;
    $[4] = referencedNfts;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onRemovePart || $[8] !== partIndex) {
    t5 = () => onRemovePart(partIndex);
    $[7] = onRemovePart;
    $[8] = partIndex;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="tw-h-4 tw-w-4 tw-text-error tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div className="touch-visible tw-absolute tw-right-0 tw-top-1 tw-hidden tw-transition tw-duration-300 tw-ease-linear group-hover:tw-block"><div className="tw-flex tw-items-center tw-gap-x-2"><button type="button" onClick={t5} aria-label="Remove storm part" className="tw-group tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-none tw-bg-iron-900 tw-p-2 tw-text-xs tw-font-medium tw-text-iron-400 tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out active:tw-ring-iron-650">{t6}</button></div></div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t7) {
    t8 = <div className="tw-group tw-relative tw-flex tw-flex-col tw-gap-x-2">{t2}{t4}{t7}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default CreateDropStormPart;
function _temp() {}